// only load our form helpers if we have a form on the current page
jQuery(($) => {
    if ($('form').length || window.patternlab) {
        require.ensure([], () => {
            let loadingIndicator,
                selectAll,
                fileInput,
                floatingLabel,
                $viewportMeta = $('meta[name="viewport"]'),
                viewportMetaContent = $viewportMeta.attr('content'),
                zoomEnableTimeout = function () {};

            // prevent mobile zoom in
            $('input, select, textarea').bind('touchstart focus blur', function (event) {
                if (event.type === 'blur') {
                    zoomEnableTimeout = setTimeout(function () {
                        $viewportMeta.attr('content', viewportMetaContent);
                    }, 100);
                } else {
                    clearTimeout(zoomEnableTimeout);
                    $viewportMeta.attr('content', viewportMetaContent + ',maximum-scale=1');
                }
            });

            // automatically attach an loading indicator to submit buttons on form submit
            loadingIndicator = require('@spinnwerk/form-helper/loading-indicator').default;
            loadingIndicator();

            // enable an (de)select all radiobutton and checkboxes possibility
            selectAll = require('@spinnwerk/form-helper/select-all').default;
            selectAll();

            // style advanced file inputs
            fileInput = require('@spinnwerk/form-helper/file-input').default;
            fileInput({
                multibleFilesLabel: ':anz Dateien ausgewählt'
            });

            // automatically attach an loading indicator to submit buttons on form submit
            floatingLabel = require('@spinnwerk/form-helper/label-floating').default;
            floatingLabel();

            // include form validation via parsley (with German language)
            require('./validation');

        }, 'form-helpers');
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/lib/form/form.js